// Risk-bucket badge — FE-036 / spec §7.0.7.

import type { ClientPerformanceRow } from "@/features/dashboard";


type RiskBucket = ClientPerformanceRow["risk_bucket"];


const META: Record<RiskBucket, { label: string; classes: string }> = {
  critical: {
    label: "Critical",
    classes: "bg-ember-tint text-ember",
  },
  high: {
    label: "High",
    classes: "bg-gold-tint text-ember",
  },
  medium: {
    label: "Medium",
    classes: "bg-recessed text-text-primary",
  },
  low: {
    label: "Low",
    classes: "bg-sage-tint text-teal",
  },
};


export function RiskBadge({ bucket }: { bucket: RiskBucket }) {
  const meta = META[bucket];
  return (
    <span
      data-testid={`risk-badge-${bucket}`}
      data-bucket={bucket}
      className={[
        "inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium",
        meta.classes,
      ].join(" ")}
    >
      {meta.label}
    </span>
  );
}
